const sectionCardSmokingCss = `
[data-type='section-card-smoking'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-card-smoking'] .card-layout {
  display: flex;
  flex-wrap: wrap;
}

[data-type='section-card-smoking'] .card-layout .card-left {
  width: calc(50% - 12px);
  padding: 30px 0;
}

[data-type='section-card-smoking'] .card-layout .card-left[data-order='2'] .card-content {
  transform: translateX(-40px);
}

[data-type='section-card-smoking'] .card-layout .card-left .card-content {
  width: calc(100% + 40px);
  color: #fff;
  position: relative;
  z-index: 10;
  overflow: hidden;
  border-radius: 10px;
  padding: 50px;
}

[data-type='section-card-smoking'] .card-layout .card-left .card-content .card-title h2 {
  font-size: 24px;
}

[data-type='section-card-smoking'] .card-layout .card-right {
  width: calc(50% + 12px);
}

[data-type='section-card-smoking'] .card-layout .card-right .wrap-img {
  overflow: hidden;
  border-radius: 10px;
}

[data-type='section-card-smoking'] .card-layout .card-right .wrap-img img {
  width: 100%;
  height: auto;
  display: block;
}

@container (max-width: 768px) {
  [data-type='section-card-smoking'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-card-smoking'] .card-layout .card-left {
    order: 2 !important;
    width: 100%;
    padding: 0 20px;
  }

  [data-type='section-card-smoking'] .card-layout .card-left[data-order='2'] .card-content {
    transform: translateY(-30px);
  }

  [data-type='section-card-smoking'] .card-layout .card-left .card-content {
    width: 100%;
    padding: 20px;
  }

  [data-type='section-card-smoking'] .card-layout .card-right {
    order: 1 !important;
    width: 100%;
  }
}
`;

export default sectionCardSmokingCss;
